import { render, staticRenderFns } from "./SideMenuLinkSP.vue?vue&type=template&id=3f87a325&scoped=true"
import script from "./SideMenuLinkSP.vue?vue&type=script&lang=ts"
export * from "./SideMenuLinkSP.vue?vue&type=script&lang=ts"
import style0 from "./SideMenuLinkSP.vue?vue&type=style&index=0&id=3f87a325&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f87a325",
  null
  
)

export default component.exports